import { createFileRoute, redirect } from '@tanstack/react-router'
import { ProductEditView } from '@/features/products/products'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/products/$productId/edit')({
  beforeLoad: ({ context, params }) => {
    if (!hasGrant(context.queryClient, 'product.edit')) {
      throw redirect({
        to: '/products/$productId',
        params: { productId: params.productId },
      })
    }
  },
  component: ProductEditView,
})
